import React from 'react';
import { BaseField } from 'react/components/fields';
import PropTypes from 'prop-types';

const renderFieldContent = ({
  id,
  input,
  options,
  disabled
}) => (
  <div id={id}>
    {
      options.map((option) => (
        <div className="checkboxGroupOption" key={option.value}>
          <input
            id={`${id}-${option.value}`}
            name={id}
            value={option.value}
            type="checkbox"
            checked={!!input.value[option.value]}
            onChange={(e) => {
              input.onBlur();
              input.onChange({ ...input.value, [option.value]: e.target.checked });
            }}
            disabled={disabled}
          />
          <label htmlFor={`${id}-${option.value}`}>
            {option.label}
          </label>
        </div>
      ))
    }
  </div>
);

const CheckboxGroupField = (props) => {
  const { required } = props;
  const customValidation = (values) => (
    (required && !Object.values(values || {}).some((value) => value)) ? 'general.mandatoryField' : undefined
  );

  return (
    <BaseField
      fieldClassName="checkboxGroup"
      renderFieldContent={renderFieldContent}
      customValidation={customValidation}
      required={required}
      {...props}
    />
  );
};

renderFieldContent.propTypes = {
  id: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

renderFieldContent.defaultProps = {
  disabled: false
};

CheckboxGroupField.propTypes = {
  required: PropTypes.bool
};

CheckboxGroupField.defaultProps = {
  required: false
};

export default CheckboxGroupField;
